






















import { mapState } from 'vuex'
import Component from 'vue-class-component'
import Vue from 'vue'
import { VCard, VCardText, VCardTitle, VChip, VHover } from 'vuetify/lib/components'
import { TagInfo, TagStorage } from '@/store/tags/types'

function nonEmptyOrDefault<T> (list: T[], defaultIfEmpty: T[]): T[] {
  return list.length > 0 ? list : defaultIfEmpty
}
@Component({
  components: { VCard, VCardTitle, VCardText, VHover, VChip },
  computed: { ...mapState(['tagStorage', 'current']) }
})
export default class Tags extends Vue {
  tagStorage!: TagStorage;
  current?: { game?: { tags?: string[] } }
  get currentTags () {
    return (this.current?.game?.tags ?? []).join(', ') || 'Tous les thèmes'
  }

  get tagsByTheme () {
    const res: Record<string, Record<string, TagInfo[]>> = {}
    const allThemes = this.tagStorage.getThemes();
    [...this.tagStorage.getAllNonThemeTags()].map(t => this.tagStorage.get(t))
      .forEach(t => {
        if (!t) return
        const thisThemes = nonEmptyOrDefault([...t.requires].filter(a => allThemes.includes(a)), ['__theme'])
        const thisNotThemes = [...t.isA].filter(a => !thisThemes.includes(a) && a !== '__theme')
        thisThemes.forEach(theme => {
          const themeMap = (res[theme] = res[theme] ?? {})
          thisNotThemes.forEach(type => {
            const typeList = (themeMap[type] = themeMap[type] ?? [])
            typeList.splice(typeList.length, 0, t)
          })
        })
      })
    return res
  }

  get displayMap (): Record<string, string> {
    return {
      __theme: 'Défaut',
      __name__: 'Nom Aléatoire'
    }
  }

  labelOf (type: string): string {
    return this.displayMap[type] ?? this.tagStorage.get(type)?.value ?? type
  }
}
